module.exports = __webpack_public_path__ + "static/media/3.4e503054.mkv";